<template>
    <div class="w-full relative text-gray-300 dark:text-gray-600">
      <!-- Input -->
      <input :disabled="disabled" v-model="value" :type="showPassword ? 'text' : type" :id="`input-${label}`"
      autocomplete="off"
      @input="$emit('update:modelValue', $event.target.value); v ? v.$touch() : null;"
      @focus="onFocus = true" @blur="onFocus = false"
      :class="value ? 'text-gray-400 border-gray-400 dark:border-gray-500 dark:text-gray-500' : ''"
      class="w-full block bg-transparent h-10 shadow-sm pl-2
      border border-gray-300 dark:border-gray-600 focus:border-transparent rounded-md
      focus:ring-indigo-500 focus:ring-2
      focus:text-gray-500
      disabled:border-0 disabled:shadow-none
      transition-all duration-300"/>

      <!-- Label -->
      <label @click="giveFocus()"
      :class="onFocus ? 'text-indigo-500 -top-3 bg-gray-50 dark:bg-gray-900 px-1 text-sm' : value !== '' ? '-top-3 bg-gray-50 dark:bg-gray-900 px-1 text-sm text-gray-400 dark:text-gray-500' : ''"
      class="absolute ml-2 top-2 transition-all duration-300 select-none cursor-text">{{label}}</label>
      
      <!-- Erro -->
      <span v-if="v">
      <span class="text-xs text-red-600 ml-1 transition-all duration-300" v-if="v.$error">{{v.$errors[0].$message}}</span>
      </span>
      <!-- Toggle Password (only display if input type is password) -->
      <span class="absolute top-2 -mx-8 left-full text-gray-600 cursor-pointer select-none" v-if="type === 'password'">
        <span v-if="!showPassword" @click="showPassword = true" class="material-icons-outlined">
          visibility_off
        </span>
        <span v-else @click="showPassword = false" class="material-icons-outlined">
          visibility
        </span>
      </span>
    </div>
</template>

<script>
import { ref, reactive   } from '@vue/reactivity'
import Icon from '@/components/Design/Icon'
import { computed } from '@vue/runtime-core'
export default {
  name: 'Input',
  props: ['type', 'modelValue', 'label', 'validation', 'disabled'],
  components: {
    Icon
  },
  setup(props) {
    const onFocus = ref(false)
    const showPassword = ref(false)

    // Props
    const type = computed(() => {
      return props.type
    })
    const label = computed(() => {
      return props.label
    })
    const value = computed(() => {
      return props.modelValue
    })
    // const value = props.modelValue
    const v = props.validation

    // Functions
    const giveFocus = (() => {
      document.getElementById(`input-${label.value}`).focus()
    })
    return {
      onFocus, 
      type, 
      showPassword, 
      value, 
      label, 
      giveFocus, 
      v
    }
  }
}
</script>
